<template>
  <div class="cl-inner">
    <!-- 搜索 -->
    <div class="search-inner">
      <a-form layout="inline">
        <a-form-item class="name" label="课程方名称">
          <a-input class="form-cell" type="text" v-model="queryParam.institutionName"></a-input>
        </a-form-item>
        <a-form-item label="地区" class="form-oper" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
          <a-cascader v-if="
            $store.state.common.address &&
            $store.state.common.address.length > 0
          " class="form-cell" :options="$store.state.common.address" placeholder="请选择" changeOnSelect v-model="queryParam.addressSelect"
            :fieldNames="{ label: 'name', value: 'id', children: 'children' }" />
        </a-form-item>

        <!-- 审核状态 -->
        <a-form-item label="审核状态" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
          <a-select class="form-cell" placeholder="请选择" v-model="queryParam.status">
            <a-select-option value="2">待审核</a-select-option>
            <a-select-option value="3">审核通过</a-select-option>
            <a-select-option value="4">审核不通过</a-select-option>
          </a-select>
        </a-form-item>

        <!-- 课程方种类 -->
        <a-form-item label="课程方种类" :labelCol="{ lg: { span: 7 } }" :wrapperCol="{ lg: { span: 13 } }">
          <a-select class="form-cell" placeholder="请选择" v-model="queryParam.institutionType">
            <a-select-option v-for="(item, index) in institutionTypeList" :key="index" :value="item.id"><span>{{ item.value }}</span></a-select-option>
          </a-select>
        </a-form-item>

        <a-form-item class="search-oper">
          <a-button type="primary" @click="searchInstitution()">查询</a-button>
          <a-button type="primary" @click="() => (queryParam = {})">重置</a-button>
        </a-form-item>
      </a-form>
    </div>

    <!-- 操作 -->
    <!-- <div class="list-oper" v-if="roleId == '2'">
      <a-button type="primary" icon="plus" @click="$refs.institutionForm.init('add')">新建</a-button>
    </div> -->

    <!-- 表格数据 -->
    <a-table :columns="columns" :dataSource="institutionList" class="c-table" :pagination="pagination" :loading="loading" @change="tableChange" :rowKey="getRowKey">
      <span slot="bailAmount" slot-scope="text, record">
        <template>
          <span>{{ record.bailAmount ? record.bailAmount / 100 : '' }}</span>
        </template>
      </span>
      <span slot="address" slot-scope="text, record">
        <template>
          <span>{{ record.provinceId | codeFilter }}{{ record.cityId | codeFilter
            }}{{ record.districtId | codeFilter }}</span>
        </template>
      </span>
      <span slot="gmtCreate"></span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a v-if="roleId == '6'" @click="$refs.institutionAmount.init(record)">设置保证金</a>
          <a-divider v-if="roleId == '6'" type="vertical" />
          <!-- <a @click="$refs.institutionDetail.init(record)">{{
            record.status == '2' ? '审核' : '详情'
          }}</a> -->
          <a @click="$refs.institutionDetail.init(record)">详情</a>
          <a-divider v-if="roleId == '6'" type="vertical" />
          <a v-if="roleId == '6'" @click="verify(record)">核实</a>
          <!-- <a-divider v-if="roleId == '2'" type="vertical" />
          <a  v-if="roleId == '2'" @click="$refs.institutionForm.init('update',record)">修改</a>
          <a-divider  v-if="roleId == '2'" type="vertical" />
          <a v-if="roleId == '2'" @click="deleteInstitution(record)">删除</a> -->
        </template>
      </span>
      <span slot="institutionName" slot-scope="text, record">
        <template>
          <span><a @click="tryLogin(record.id,record.status)">{{ record.institutionName }}</a><a-tag v-if="record.institutionType == 3" color="blue">高协</a-tag></span>
        </template>
      </span>
    </a-table>

    <a-modal :width="615" :maskClosable="false" v-model="verifyVisible" title="机构资料核实修改" @ok="verifyOk">
      <div style="margin-left: 115px">
        <a-radio-group v-model="showType" name="radioGroup" :default-value="1">
          <a-radio :style="radioStyle" :value="1">
            核实通过：教育局可对机构进行审核
          </a-radio>
          <a-radio :style="radioStyle" :value="0">
            未核实：教育局提示"申请机构相关信息真实性核实中"
          </a-radio>
        </a-radio-group>
      </div>
    </a-modal>
    <!-- 教育局不显示新增 -->
    <!-- <institution-form-modal ref="institutionForm" @addInstitution="addInstitution" @updateData="updateData"></institution-form-modal> -->

    <institution-detail-modal ref="institutionDetail" @updateData="updateData"></institution-detail-modal>

    <institution-amount-modal ref="institutionAmount" @updateData="updateData"></institution-amount-modal>
  </div>
</template>
<script>
import CTable from '../../components/CTable'

import person from '../../api/person'

import institution from '../../api/institution'

//import InstitutionFormModal from './InstitutionFormModal'

import InstitutionDetailModal from './InstitutionDetailModal'

import InstitutionAmountModal from './InstitutionAmountModal'

import { analysisAddress } from '../../utils/address'

const columns = [
  {
    title: '课程方名称',
    dataIndex: 'institutionName',
    key: 'institutionName',
    scopedSlots: {
      customRender: 'institutionName',
    },
  },
  {
    title: '课程方种类',
    dataIndex: 'institutionTypeName',
    key: 'institutionTypeName',
  },
  {
    title: '课程方类型',
    dataIndex: 'classifyName',
    key: 'classifyName',
  },
  {
    title: '教育局',
    dataIndex: 'bureauName',
    key: 'bureauName',
  },
  {
    title: '保证金',
    dataIndex: 'bailAmount',
    key: 'bailAmount',
  },
  {
    title: '负责人名称',
    dataIndex: 'nickname',
    key: 'nickname',
  },
  {
    title: '地区',
    dataIndex: 'address',
    key: 'address',
    scopedSlots: { customRender: 'address' },
  },
  {
    title: '审核状态',
    dataIndex: 'statusText',
    key: 'statusText',
  },
  {
    title: '创建时间',
    dataIndex: 'gmtCreate',
    key: 'gmtCreate',
    sorter: true,
  },
  {
    title: '操作',
    dataIndex: 'action',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'institutionList',
  data() {
    return {
      institutionList: [], //课程方数据
      columns: JSON.parse(JSON.stringify(columns)), //列标识数据
      queryParam: {}, //查询参数
      pagination: {
        showTotal: (total) => `总共 ${total} 条`, // 显示总数
      }, //分页数据对象
      loading: true,
      noBureau: false, //不是教育局
      roleId: '',
      institutionTypeList: [
        { id: 1, value: '社会企业' },
        { id: 2, value: '个人老师' },
        { id: 3, value: '高校与协会' },
      ],
      verifyVisible: false,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px',
      },
      showType: 1,
      id: '',
    }
  },
  components: {
    CTable,
    //InstitutionFormModal,
    InstitutionDetailModal,
    InstitutionAmountModal,
  },
  methods: {
    getRowKey(record, index) {
      return index;
    },
    //核实确认
    verifyOk() {
      console.log('核实确认', this.showType)
      console.log('this.id', this.id)
      institution
        .institutionVerify({ institutions: this.id, status: this.showType })
        .then((res) => {
          this.$message.success('操作成功')
          this.verifyVisible = false
          this.getInstitutionList(this.queryParam)
          this.showType = 1
        })
    },
    //核实
    verify(record) {
      this.verifyVisible = true
      this.showType = Number(record.informationVerify)
      this.id = record.id
    },
    //更新当前修改的数据
    updateData(value) {
      for (let i in this.institutionList) {
        if (this.institutionList[i].id == value.id) {
          this.$set(this.institutionList, i, value)
        }
      }
    },

    //table发生该表，分页，排序
    tableChange(pagination, filters, sorter) {
      //如果查询有地区的话，把地区解析之后带入
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = pagination.current
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      //存在排序的时候
      if (sorter && sorter.columnKey) {
        obj.sorter = `${sorter.columnKey}-${sorter.order == 'ascend' ? 'asc' : 'desc'
          }`
      }
      this.getInstitutionList(obj)
    },

    //新增一个课程方
    addInstitution(institution) {
      this.institutionList.unshift(institution)
    },

    //删除课程方
    deleteInstitution(value) {
      let self = this
      this.$confirm({
        title: '确定要删除吗?',
        okText: '确定',
        cancelText: '取消',
        content: '删除后，无法撤销',
        onOk() {
          institution.deleteInstitution(value.id).then((res) => {
            self.$message.success('删除成功')
            //前端模拟删除
            self.deleteInstitutionData(self.institutionList, value.id)
          })
        },
      })
    },

    //删除数据
    deleteInstitutionData(data, id) {
      for (let i in data) {
        if (data[i].id == id) {
          data.splice(i, 1)
          break
        }
      }
    },

    //查询课程方
    searchInstitution() {
      let obj = analysisAddress(this.queryParam)
      obj.currentPage = 1
      window.location.hash = `#${this.$route.path}?params=${JSON.stringify(
        obj
      )}`
      this.getInstitutionList(obj)
    },

    //课程方列表
    getInstitutionList(params) {
      this.loading = true
      institution.getInstitutionList(params).then((res) => {
        console.log('当前的课程方列表是', res.data.list)
        this.institutionList = res.data.list
        this.loading = false
        //分页信息
        this.pagination = res.data.pagination
      })
    },
    tryLogin(institutionId,status) {
      if (status !== 3) {
        this.$message.error("机构还未审核通过")
        return
      }
      this.loading = true
      institution.loginInstitutionByPlatformAdmin(institutionId).then((res) => {
        if (res.code == 0) {
          let domain = "https://" + res.data.domain.trim();
          // if (location.href.indexOf("localhost")) {
            // domain = "http://localhost:" + location.port
          // }
          var url = `${domain}/?accessToken=${res.data.accessToken.accessToken}&refreshToken=${res.data.accessToken.refreshToken}#/login`;
          window.location.replace(url);
        } else {
          this.$message.success(res.data.msg);
        }
      }).finally(() => { this.loading = false })
    },
  },
  created() {
    if (this.$route.query.params) {
      this.queryParam = JSON.parse(this.$route.query.params)
      let arr = []
      if (this.queryParam.provinceId) {
        arr[0] = this.queryParam.provinceId
      }
      if (this.queryParam.cityId) {
        arr[1] = this.queryParam.cityId
      }
      if (this.queryParam.districtId) {
        arr[2] = this.queryParam.districtId
      }
      this.queryParam.addressSelect = arr
    } else {
      this.queryParam = {}
    }
    this.getInstitutionList(this.queryParam)
    this.$store.dispatch('getUserInfo').then((res) => {
      //如果是教育局负责人
      this.noBureau = res.accRole.id == '2' ? false : true
      this.roleId = res.accRole.id
      //如果是教育局，去除操作
      // if(!this.noBureau){
      //   this.columns.length = this.columns.length - 1;
      // }
    })
  },
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';

.search-inner {
  margin-bottom: 20px;
}

.cl-inner {
  width: calc(100% - 40px);
  padding: 20px;
  background: white;
  margin: 20px auto;
}

.search-oper {
  button {
    margin: 0px 5px;
  }
}

.list-oper {
  margin: 20px 0px 30px;
}
</style>
